(ns frontend.ui.component.image-cropper.core
  (:require
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(defn init-props
  []
  (let [state (r/atom {:crop {:x 0 :y 0}
                       :zoom 1})]
    {:state          state
     :on-crop-change #(swap! state assoc :crop %)
     :on-zoom-change #(swap! state assoc :zoom (js/parseFloat (dg/event-target-value %)))
     :set-cropping   (fn [area pixels]
                       (swap! state assoc
                         :area area
                         :pixels pixels))}))
